export const localToUTCDate = (date?: Date): Date | undefined =>
  date
    ? new Date(
        Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
      )
    : undefined;

export const utcToLocalDate = (date?: Date): Date | undefined =>
  date
    ? new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
    : undefined;
